import { TwinManagementSettings } from "../../components/twinManagement/types";
import MaintenanceTicketForm from "../../maintenance/components/MaintenanceTicketForm.vue";
import { assetManagementTicketType } from "../constants";
import { ticketManagementPrefix } from "../../maintenance/constants";

export const assetManagementSettings: TwinManagementSettings = {
  prefix: "asset.produktion.*",
  label: "assets",
  baseRoute: "assetManagement",
  listViewName: "assetManagementList",
  detailViewName: "assetManagementDetail",
  additionalRoutes: [
    {
      id: "asset-reports",
      name: "reports",
      translate: true,
      type: "routerlink",
      isDropDown: true,
      route: { name: "assetReportsOverview" },
      children: [
        {
          id: "assets",
          name: "assets",
          translate: true,
          type: "routerlink",
          route: { name: "assetReports" },
        },
        {
          id: "asset-changelog",
          name: "assetChangelog",
          translate: true,
          type: "routerlink",
          route: { name: "assetReportChangelogs" },
        },
      ],
    },
  ],
  documents: [
    {
      category: "twinDocument",
      title: "technicalSpecificationsAndEquipmentEngineeringDocuments",
    },
    {
      category: "twinDocument/Maintenance",
      title: "equipmentLifecycleDocumentationAndMaintenanceRecords",
    },
  ],
  tickets: [
    {
      type: ticketManagementPrefix,
      label: "maintenanceTickets",
      createComponent: MaintenanceTicketForm,
    },
  ],
  hideReferenceTypes: [assetManagementTicketType],
  referenceTabs: [
    { label: "warehouse", includeReferenceTypes: ["wh."] },
    { label: "components", includeReferenceTypes: ["asset."] },
  ],
  reportOverview: {
    staticReports: [
      {
        route: { name: "assetReports" },
        title: "assets",
        description: "assetReportsDescription",
      },
      {
        route: { name: "assetReportChangelogs" },
        title: "assetChangelog",
        description: "assetChangelogReportsDescription",
      },
    ],
    dynamicReportRouteName: "assetCustomReport",
  },
};
